// Azure dev environment. Opt in with `ng serve --configuration azure` (or `ng build --configuration azure`).
// Points the portal at the Identity server deployed to Azure Container Apps (dev, Central India).
export const environment = {
  production: false,
  // Custom domain bound to the ACA Identity app (free managed cert). The value is the discovery document's
  // `issuer` verbatim (trailing slash included) — forwarded-headers handling derives it from this host.
  oauthIssuer: 'https://identities.dev.sphynch.com/',
  // Same-origin in the cloud: the SPA is served at provision.dev.sphynch.com and the nginx edge proxies
  // /api → the API container. An empty base makes BackendService emit relative `/api/v1/...` URLs (no CORS).
  apiBaseUrl: '',
  ecommerceApiBaseUrl: '',
  // Empty in the dev cloud too → Create Staff User shows a full email field so activation emails can be sent to
  // a reachable throwaway inbox for end-to-end testing. Production locks this to 'sphynch.com' (environment.prod.ts).
  staffEmailDomain: '',
}
